import match from 'autosuggest-highlight/match';
import sum from 'lodash/sum';
import { removeAccents } from '@uno/common-shared';
import { TERM_HIERARCHY_DISPLAY_SEPARATOR } from 'config/constants';
var PERFECT_MATCH_SCORE = 9999;
var SUBSECTION_MATCH_SCORE = 1000;
var SUBSECTION_ALLOWED_LEVELS = 8;

var getSubSectionScore = function getSubSectionScore(subSections, search) {
  if (search.indexOf(TERM_HIERARCHY_DISPLAY_SEPARATOR) > 0) {
    return sum(search.split(TERM_HIERARCHY_DISPLAY_SEPARATOR).map(function (searchTerm) {
      return getSubSectionScore(subSections, searchTerm);
    }));
  }

  var index = subSections.indexOf(search);

  if (index < 0) {
    return 0; // Not Found
  } // The earliest in hierarchy it is found, the higher is the score:


  return Math.max(SUBSECTION_ALLOWED_LEVELS - index, 1) * SUBSECTION_MATCH_SCORE;
};

var getOptionScore = function getOptionScore(optionText, searchText) {
  var text = removeAccents(optionText.toLowerCase());
  var search = removeAccents(searchText.toLowerCase());
  var test = match(text, search);
  return test.length + (text === search ? PERFECT_MATCH_SCORE : getSubSectionScore(text.split(TERM_HIERARCHY_DISPLAY_SEPARATOR), search));
};

export default getOptionScore;